import type { NotificationSection } from './types';

type NotificationRegisteredSection = {
  type: string;
  group: 'data-updates' | 'shared-objects' | 'recommendation-alert';
  order: number;
  component: NotificationSection;
};
class NotificationPreferenceRegister {
  private static instance: NotificationPreferenceRegister;

  private registry: NotificationRegisteredSection[] = [];
  private listeners: ((registry: NotificationRegisteredSection[]) => void)[] = [];

  private constructor() {}

  public register(type: NotificationRegisteredSection): void {
    this.registry.push(type);
    this.listeners.forEach(cb => cb(this.registry));
  }

  public get(type: string): NotificationSection | null {
    return this.registry.find(item => item.type === type)?.component || null;
  }

  public getAll(callback?: (registry: NotificationRegisteredSection[]) => void): NotificationRegisteredSection[] {
    if (callback) {
      this.listeners.push(callback);
    }
    return this.registry;
  }

  public static getInstance(): NotificationPreferenceRegister {
    if (!NotificationPreferenceRegister.instance) {
      NotificationPreferenceRegister.instance = new NotificationPreferenceRegister();
    }
    return NotificationPreferenceRegister.instance;
  }

  public static reset() {
    NotificationPreferenceRegister.instance = undefined;
  }
}

export { NotificationPreferenceRegister, NotificationRegisteredSection };
